"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContext = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var FilterTypings_1 = require("../Components/Filters/FilterTypings");
var PageContext = /** @class */ (function () {
    function PageContext() {
    }
    Object.defineProperty(PageContext, "dictionary", {
        get: function () {
            return PageContext.data.dictionary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "searchDictionary", {
        get: function () {
            return PageContext.data.dictionary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "filterableDictionary", {
        get: function () {
            return PageContext.data.dictionary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "type", {
        get: function () {
            return PageContext.data.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "pageName", {
        get: function () {
            return PageContext.data.pageName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "pageId", {
        get: function () {
            return PageContext.data.pageId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "sortBy", {
        get: function () {
            return PageContext.data.sortBy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "sortOptions", {
        get: function () {
            return PageContext.data.sortOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageContext, "title", {
        get: function () {
            return PageContext.data.title;
        },
        enumerable: false,
        configurable: true
    });
    PageContext.initContext = function (type, element, dictionary) {
        PageContext.data = {
            dictionary: dictionary,
            type: type,
            title: app_1.AttrService.data(element, 'page-heading'),
            pageId: app_1.AttrService.data(element, 'pageid'),
            pageName: app_1.AttrService.data(document.querySelector('.dynamic-page'), 'gtm-page'),
            sortBy: PageContext.getSortByByType(type),
            sortOptions: PageContext.getSortOptionByType(type, dictionary),
        };
    };
    PageContext.getSortOptionByType = function (type, dictionary) {
        var defaultSort = {
            label: dictionary.sortTitleDefaultLabel,
            value: FilterTypings_1.FilterSortOptions.Default,
        };
        var titleAsc = {
            label: dictionary.sortTitleAscLabel,
            value: FilterTypings_1.FilterSortOptions.TitleAsc,
        };
        var titleDesc = {
            label: dictionary.sortTitleDescLabel,
            value: FilterTypings_1.FilterSortOptions.TitleDesc,
        };
        var startDateAsc = {
            label: dictionary.sortStartDateAscLabel,
            value: FilterTypings_1.FilterSortOptions.StartDateAsc,
        };
        var startDataDesc = {
            label: dictionary.sortStartDateDescLabel,
            value: FilterTypings_1.FilterSortOptions.StartDataDesc,
        };
        var fromNowToFuture = {
            label: dictionary.nowToFuture,
            value: FilterTypings_1.FilterSortOptions.FromNowToFuture,
        };
        var fromFutureToNow = {
            label: dictionary.futureToNow,
            value: FilterTypings_1.FilterSortOptions.FromFutureToNow,
        };
        var pastEvents = {
            label: dictionary.pastEvents,
            value: FilterTypings_1.FilterSortOptions.PastEvents,
        };
        var allSort = {
            label: dictionary.sortAllLabel,
            value: FilterTypings_1.FilterSortOptions.TitleAsc,
        };
        var softwareReleaseDateAsc = {
            label: dictionary.sortNewestToOldestLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateDesc,
        };
        var softwareReleaseDateDesc = {
            label: dictionary.sortOldestToNewestLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateAsc,
        };
        var softwareReleaseDateRelevance = {
            label: dictionary.sortRelevanceLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateRelevance,
        };
        var result;
        switch (type) {
            case FilterTypings_1.FilterableListTypeEnum.SearchResults:
                result = [softwareReleaseDateRelevance, softwareReleaseDateAsc, softwareReleaseDateDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
                result = [startDateAsc, startDataDesc, allSort];
                break;
            case FilterTypings_1.FilterableListTypeEnum.News:
                result = [startDataDesc, startDateAsc, allSort];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Downloads:
                result = [titleAsc, titleDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Products:
                result = [defaultSort, titleAsc, titleDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Events:
                result = [
                    fromNowToFuture,
                    fromFutureToNow,
                    pastEvents,
                    tslib_1.__assign(tslib_1.__assign({}, allSort), { value: FilterTypings_1.FilterSortOptions.StartDataDesc }),
                ];
                break;
        }
        return result;
    };
    PageContext.getSortByByType = function (type) {
        var result;
        switch (type) {
            case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
            case FilterTypings_1.FilterableListTypeEnum.News:
                result = FilterTypings_1.FilterSortOptions.StartDataDesc;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Downloads:
                result = FilterTypings_1.FilterSortOptions.TitleAsc;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Products:
                result = FilterTypings_1.FilterSortOptions.Default;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Events:
                result = FilterTypings_1.FilterSortOptions.FromNowToFuture;
                break;
            case FilterTypings_1.FilterableListTypeEnum.SearchResults:
                result = FilterTypings_1.FilterSortOptions.SoftwareReleaseDateRelevance;
                break;
        }
        return result;
    };
    PageContext.data = {};
    return PageContext;
}());
exports.PageContext = PageContext;
